import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateYouTubeApiCall({
  id,
  isPathDesign,
  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  youTubeLayout,
  youTubeView,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.youtube, isPathDesign), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    layout: youTubeLayout,
    view: youTubeView,
  });
}
